const filter = () => {
  const container = document.querySelector('.filtered');

  function empty(el) {
    try {
      while (el.firstChild) {
        el.removeChild(el.firstChild);
      }
    } catch (error) {
      console.error('Failed to empty the element: ' + error);
    }
  }

  function populateFilteredContentContainer(container, children) {
    try {
      children.forEach(function (el) {
        const clonedEl = el.cloneNode(true);
        container.appendChild(clonedEl);
      });
    } catch (error) {
      console.error('Failed to populate container: ' + error);
    }
  }

  if (container) {
    const clonedContainer = container.cloneNode(false);
    clonedContainer.setAttribute('id', 'cloned');
    clonedContainer.setAttribute('style', 'display: none;');

    container.parentElement.insertBefore(clonedContainer, container);

    const filterOptions = document.querySelectorAll('.btn-filter-option');

    filterOptions.forEach(function (el) {
      el.addEventListener('click', function () {
        const currentActiveFilter = document.querySelector('.btn-filter-option.active');
        currentActiveFilter.classList.remove('active');
        this.classList.add('active');
        const allItems = container.children;
        const filteredItems = [];

        for (let i = 0; i < allItems.length; i++) {
          if (allItems[i].dataset.category != undefined && allItems[i].dataset.category.includes(el.dataset.filter)) {
            filteredItems.push(allItems[i]);
          }
        }

        empty(clonedContainer);

        if (this.dataset.filter != container.getAttribute('id')) {
          populateFilteredContentContainer(clonedContainer, filteredItems);
          container.setAttribute('style', 'display: none;');
          clonedContainer.removeAttribute('style');
        } else {
          container.removeAttribute('style');
          clonedContainer.setAttribute('style', 'display: none;');
        }
      });
    });
  }
};

export default filter;



// WEBPACK FOOTER //
// ./scripts/filter.js